import {
  seriesDisplayModeOptions,
  SeriesDisplayMode,
} from '../types/tooltip.js';

/**
 * Returns true if seriesDisplayMode is a valid SeriesDisplayMode
 * @param seriesDisplayMode - series diplay mode
 */
export const isValidSeriesDisplayMode = (
  seriesDisplayMode: string,
): seriesDisplayMode is SeriesDisplayMode =>
  (seriesDisplayModeOptions as unknown as string[]).includes(seriesDisplayMode);
